var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-box",class:{ isMobile: _vm.isMobile }},[(!_vm.isMobile)?_c('header-top'):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-header'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('router-view')],1),_vm._v(" "),_c('footer-bottom'),_vm._v(" "),_c('right-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/index.vue?vue&type=template&id=cb213f14&scoped=true
// module id = null
// module chunks = 